import { atom } from "jotai";

export const trackedLemmaIdsAtom = atom<number[]>([]);
export const trackedLemmasCountAtom = atom<number>(0);

export const isLemmaTrackedAtom = atom(
  (get) => (lemmaId: number) => get(trackedLemmaIdsAtom).includes(lemmaId),
);
